export default {
  name: "users",
  components: {},
  props: [],
  data() {
    return {
      items: []
    };
  },
  computed: {},
  mounted() {
    this.GetUsers();
  },
  methods: {
    async GetUsers() {
      await this.$helpers
        .PostApi("get/users", {})
        .then(res => {
          this.items = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
